import { Button } from '@/ui/design-system/components/ui/button';
import ExtLink from 'components/ExtLink';
import { cn } from '@/ui/design-system/utils/cn';
import { forwardRef } from 'react';

const INTENT_TO_VARIANT = {
    primary: 'default',
    secondary: 'outline',
};

/**
 * ExtLink already handles its own Mixpanel tracking via mixpanelTrackLinks,
 * so this component does NOT use withMixpanelClick to avoid double-tracking.
 */
const TrackedExtLinkButton = forwardRef(function TrackedExtLinkButton(
    {
        IconLeft,
        IconRight,
        children,
        isDisabled,
        intent = 'primary',
        wrapText = false,
        variant,
        size,
        mixpanelContext,
        className,
        href,
        ...props
    },
    ref,
) {
    return (
        <Button
            ref={ref}
            variant={variant || INTENT_TO_VARIANT[intent] || 'default'}
            size={size || 'default'}
            disabled={!!isDisabled}
            asChild
            className={cn(
                'no-underline',
                wrapText && 'whitespace-normal',
                className,
            )}
        >
            <ExtLink
                href={href}
                mixpanelContext={mixpanelContext}
                unstyled
                {...props}
            >
                {IconLeft && (
                    <span className="size-4 shrink-0 flex items-center">
                        <IconLeft className="!size-[1.2em] shrink-0 opacity-50" />
                    </span>
                )}
                {children}
                {IconRight && (
                    <span className="size-4 shrink-0 flex items-center">
                        <IconRight className="!size-[1.2em] shrink-0 opacity-50" />
                    </span>
                )}
            </ExtLink>
        </Button>
    );
});

export default TrackedExtLinkButton;
